// device data
export const ALL = "ALL";

export const APP_LOADED = "APP_LOADED";
export const SEND_CACHED_STARTUP_EVENTS = "SEND_CACHED_STARTUP_EVENTS";
export const DEVICE_DETAIL = "DEVICE_DETAIL";
export const PERSIST_LOCALSTORAGE = "PERSIST_LOCALSTORAGE";
export const NEW_VISUAL_VEWPORT = "NEW_VISUAL_VEWPORT";

// install
export const INSTALL_AVAILABLE = "INSTALL_AVAILABLE";
export const INSTALL = "INSTALL";
export const INSTALL_SUCCESS = "INSTALL_SUCCESS";
export const INSTALL_ERROR = "INSTALL_ERROR";

// download
export const DOWNLOAD = "DOWNLOAD";
export const DOWNLOAD_SUCCESS = "DOWNLOAD_SUCCESS";
export const DOWNLOAD_ERROR = "DOWNLOAD_ERROR";

// share
export const COPY = "COPY";
export const COPY_SUCCESS = "COPY_SUCCESS";
export const COPY_ERROR = "COPY_ERROR";

// share
export const SHARE = "SHARE";
export const SHARE_SUCCESS = "SHARE_SUCCESS";
export const SHARE_ERROR = "SHARE_ERROR";

// crashlytics
export const CRASHLYTICS_LOG = "CRASHLYTICS_LOG";
export const CRASHLYTICS_LOG_SUCCESS = "CRASHLYTICS_LOG_SUCCESS";
export const CRASHLYTICS_LOG_ERROR = "CRASHLYTICS_LOG_ERROR";
export const CRASHLYTICS_LOG_NONFATAL_ERROR = "CRASHLYTICS_LOG_NONFATAL_ERROR";
export const CRASHLYTICS_LOG_NONFATAL_ERROR_SUCCESS = "CRASHLYTICS_LOG_NONFATAL_ERROR_SUCCESS";
export const CRASHLYTICS_LOG_NONFATAL_ERROR_ERROR = "CRASHLYTICS_LOG_NONFATAL_ERROR_ERROR";
export const CRASHLYTICS_SET_USER_ID = "CRASHLYTICS_SET_USER_ID";
export const CRASHLYTICS_SET_USER_ID_SUCCESS = "CRASHLYTICS_SET_USER_ID_SUCCESS";
export const CRASHLYTICS_SET_USER_ID_ERROR = "CRASHLYTICS_SET_USER_ID_ERROR";

// dynamic links
export const DYNAMIC_LINK_TAPPED = "DYNAMIC_LINK_TAPPED";
export const DYNAMIC_LINK_CREATE = "DYNAMIC_LINK_CREATE";
export const DYNAMIC_LINK_CREATE_ERROR = "DYNAMIC_LINK_CREATE_ERROR";
export const DYNAMIC_LINK_CREATE_SUCCESS = "DYNAMIC_LINK_CREATE_SUCCESS";

// notifications
export const GET_TOKEN = "GET_TOKEN";
export const NOTIFICATION_TAP = "NOTIFICATION_TAP";
export const REVOKE_TOKEN = "REVOKE_TOKEN";
export const OPEN_REFERRAL = "OPEN_REFERRAL";
export const UPDATE_BADGE_COUNT = "UPDATE_BADGE_COUNT";
export const REQUEST_PERMISSION_TO_SEND_NOTIFICATIONS = "REQUEST_PERMISSION_TO_SEND_NOTIFICATIONS";
export const UPDATE_DEVICE_NOTIFICATION_TOKEN = "UPDATE_DEVICE_NOTIFICATION_TOKEN";
export const WATCH_FOR_NOTIFICATION_TAPS = "WATCH_FOR_NOTIFICATION_TAPS";

// biometric authentication
export const SAVE_CREDENTIALS_TO_KEYCHAIN = "SAVE_CREDENTIALS_TO_KEYCHAIN";
export const SAVE_CREDENTIALS_TO_KEYCHAIN_SUCCESS = "SAVE_CREDENTIALS_TO_KEYCHAIN_SUCCESS";
export const SAVE_CREDENTIALS_TO_KEYCHAIN_ERROR = "SAVE_CREDENTIALS_TO_KEYCHAIN_ERROR";
export const DELETE_CREDENTIALS_FROM_KEYCHAIN = "DELETE_CREDENTIALS_FROM_KEYCHAIN";
export const DELETE_CREDENTIALS_FROM_KEYCHAIN_SUCCESS = "DELETE_CREDENTIALS_FROM_KEYCHAIN_SUCCESS";
export const DELETE_CREDENTIALS_FROM_KEYCHAIN_ERROR = "DELETE_CREDENTIALS_FROM_KEYCHAIN_ERROR";
export const GET_CREDENTIALS_FROM_KEYCHAIN = "GET_CREDENTIALS_FROM_KEYCHAIN";
export const GET_CREDENTIALS_FROM_KEYCHAIN_SUCCESS = "GET_CREDENTIALS_FROM_KEYCHAIN_SUCCESS";
export const GET_CREDENTIALS_FROM_KEYCHAIN_ERROR = "GET_CREDENTIALS_FROM_KEYCHAIN_ERROR";

// 3D touch
export const RESET_3D_TOUCH = "RESET_3D_TOUCH";
export const SETUP_3D_TOUCH = "SETUP_3D_TOUCH";

// URL
export const URL_GO = "URL_GO";
export const URL_NEW = "URL_NEW";
export const URL_OPEN = "URL_OPEN";
export const URL_OPEN_IN_BROWSER = "URL_OPEN_IN_BROWSER";

// qr code scanning
export const QR_START_SCANNING = "QR_START_SCANNING";
export const QR_STOP_SCANNING = "QR_STOP_SCANNING";
export const QR_NEW_STATUS = "QR_NEW_STATUS";
export const QR_TURN_LIGHT_ON = "QR_TURN_LIGHT_ON";
export const QR_TURN_LIGHT_OFF = "QR_TURN_LIGHT_OFF";
export const QR_USE_BACK_CAMERA = "QR_USE_BACK_CAMERA";
export const QR_USE_FRONT_CAMERA = "QR_USE_FRONT_CAMERA";
export const QR_CODE_RECOGNIZED = "QR_CODE_RECOGNIZED";
export const QR_ERROR = "QR_ERROR";

// User Location
export const USER_LOCATION_WATCH = "USER_LOCATION_WATCH";
export const USER_LOCATION_WATCH_ERROR = "USER_LOCATION_WATCH_ERROR";
export const USER_LOCATION_WATCH_CLEAR = "USER_LOCATION_WATCH_CLEAR";
export const USER_LOCATION_UPDATE = "USER_LOCATION_UPDATE";
export const USER_LOCATION_GET = "USER_LOCATION_GET";
export const USER_LOCATION_GET_ERROR = "USER_LOCATION_GET_ERROR";
export const USER_LOCATION_GET_SUCCESS = "USER_LOCATION_GET_SUCCESS";
